<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div v-if="showAddReason" class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden">
        <form @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full p-2">
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3 mb-2">
            <p class="text-base">Decline Reason</p>
            <img class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png" @click="close()" />
          </div>
          <textarea
            class="overflow-hidden form-control block w-full px-3 p-2 bg-gray-200 rounded-md py-1.5 text-base font-normal text-gray-700  bg-clip-padding border border-solid border-gray-300 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none border-0.5 "
            id="description" rows="3" placeholder="Add your reason for declining" style="background-color: #f3f3f3"
            required maxlength="100" v-model="reason"></textarea>
          <!--  @change="handleDescriptionChange" -->
          <div class="flex justify-end p-5">
            <button type="submit" class="bg-primary rounded-full px-10 text-sm text-white py-2">
              Ok
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "LeaveDeclineReason",
  props: ["showAddReason", "setReason"],
  components: { Loader },
  data() {
    return {
      reason: "",
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },

    // handleClose() {
    //   this.showAddReason = false;
    // },
    // handleCloseOnSuccess() {
    //   this.showAddReason = false;
    // },

    create() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      //console.log(this.setReason)
      this.setReason(this.reason);
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
